/**
 * Topes de tamaño al subir archivos. Los números los da la API (`GET /api/v1/uploads/limites`, desde su
 * configuración: MAX_FILE_SIZE_MB y MAX_IFC_FILE_SIZE_MB): la pantalla no los escribe. La pantalla revisa
 * ANTES de subir para no mandar cientos de MB que la API va a rechazar (cuando la API corta a media
 * subida, el navegador puede ver la conexión cerrada y no el mensaje del tope).
 */
export interface LimitesDeSubida {
  /** Tope general por archivo (MB). */
  maxArchivoMb: number;
  /** Tope de los modelos IFC (MB). */
  maxIfcMb: number;
}

/** El tope (MB) que aplica a un archivo según su tipo. */
export function topeDeSubidaMb(limites: LimitesDeSubida, nombre: string | null | undefined): number {
  return /\.ifc$/i.test(nombre ?? '') ? limites.maxIfcMb : limites.maxArchivoMb;
}

/** El mensaje cuando un archivo pasa su tope (el mismo en la API y en la pantalla). */
export function mensajeArchivoDemasiadoGrande(nombre: string | null | undefined, topeMb: number): string {
  const quien = nombre ? `El archivo "${nombre}"` : 'El archivo';
  return `${quien} pesa más de ${topeMb} MB, el máximo que se puede subir para este tipo de archivo.`;
}

/** Los archivos de la lista que pasan su tope, con su tope. */
export function archivosQuePasanElTope(
  limites: LimitesDeSubida,
  archivos: readonly { name: string; size: number }[],
): { nombre: string; topeMb: number }[] {
  return archivos
    .map((a) => ({ nombre: a.name, topeMb: topeDeSubidaMb(limites, a.name), size: a.size }))
    .filter((a) => a.size > a.topeMb * 1024 * 1024)
    .map(({ nombre, topeMb }) => ({ nombre, topeMb }));
}
